import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'
import { configure } from 'vee-validate'
import currency from '@/lang/currency'
import dates from '@/lang/dates'
import { localize, setLocale } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import ca from '@vee-validate/i18n/dist/locale/ca.json'
import fr from '@vee-validate/i18n/dist/locale/fr.json'
import de from '@vee-validate/i18n/dist/locale/de.json'
import es from '@vee-validate/i18n/dist/locale/es.json'
import it from '@vee-validate/i18n/dist/locale/it.json'
import zh_CN from '@vee-validate/i18n/dist/locale/zh_CN.json'
import zh_TW from '@vee-validate/i18n/dist/locale/zh_TW.json'
import ja from '@vee-validate/i18n/dist/locale/ja.json'
import ko from '@vee-validate/i18n/dist/locale/ko.json'
import nl from '@vee-validate/i18n/dist/locale/nl.json'
import moment from 'moment'
import 'moment/dist/locale/en-gb.js'
import 'moment/dist/locale/en-ca.js'
import 'moment/dist/locale/fr.js'
import 'moment/dist/locale/de.js'
import 'moment/dist/locale/es.js'
import 'moment/dist/locale/it.js'
import 'moment/dist/locale/zh-cn.js'
import 'moment/dist/locale/zh-tw.js'
import 'moment/dist/locale/ja.js'
import 'moment/dist/locale/ko.js'
import 'moment/dist/locale/pt.js'
import 'moment/dist/locale/nl.js'
import 'moment/dist/locale/nl-be.js'

const fallbackLocale = 'en-GB'

export const i18n = setupI18n({
  fallbackLocale: fallbackLocale,
  locale: getLanguage(),
  legacy: true,
  globalInjection: false,
  composition: false,
  datetimeFormats: dates,
  numberFormats: currency,
  warnHtmlInMessage: 'off',
  silentFallbackWarn: true,
  silentTranslationWarn: true
})

configure({
  generateMessage: localize({
    'en-US': en,
    'fr-FR': fr,
    'en-GB': en,
    'en-CA': ca,
    'de-DE': de,
    'es-ES': es,
    'it-IT': it,
    'zh-CN': zh_CN,
    'zh-TW': zh_TW,
    'ja-JP': ja,
    'ko-KR': ko,
    'nl-NL': nl
  })
})

export function getLocale() {
  return i18n.global.locale
}

export function setLocaleI18n(locale) {
  i18n.global.locale = locale
}

export function setupI18n(options = { locale: 'en' }) {
  return createI18n(options)
}

export function setI18nLanguage(locale) {
  setLocaleI18n(locale)
  setLocale(locale)
  moment.locale(locale)
  document.querySelector('html').setAttribute('lang', locale)
}

export async function loadLocaleMessages(messages) {
  for (let locale in messages) {
    i18n.global.setLocaleMessage(locale, messages[locale])
  }
  return nextTick()
}

export function getLanguage() {
  let locale = navigator.language
  if (locale.length === 2) {
    locale = `${locale}-${locale.toUpperCase()}`
  }

  if (locale.includes('en')) {
    if (locale.includes('GB')) {
      return 'en-GB'
    } else if (locale.includes('CA')) {
      return 'en-CA'
    }
    return 'en-US'
  } else if (locale.includes('fr')) {
    return 'fr-FR'
  } else if (locale.includes('de')) {
    return 'de-DE'
  } else if (locale.includes('es')) {
    return 'es-ES'
  } else if (locale.includes('it')) {
    return 'it-IT'
  } else {
    return 'en-GB'
  }
}
